<template>
    <accordion>
        <accordion-item class="mb-4">
          <!-- This slot will handle the title/header of the accordion and is the part you click on -->
            <template slot="accordion-trigger">
                <div class="summary-logo"></div>
                <h4>Resumo da encomenda</h4>
            </template>
            <!-- This slot will handle all the content that is passed to the accordion -->
            <template slot="accordion-content">
                <slot></slot>
            </template>
        </accordion-item>
    </accordion>
</template>

<script>
    import {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon
    } from 'vue-simple-accordion';
    import Accordion from "./accordion";
    import AccordionItem from "./accordion-item";

    export default {
    // ...
    components: {
        VsaList,
        VsaItem,
        VsaHeading,
        VsaContent,
        VsaIcon,
        Accordion,
        AccordionItem
    },
    props: {
        orderType: {
            required: false
        },
        customerNif: {
            required: false
        },
        customerName: {
            required: false
        },
        customerMbwayPhoneCode: {
            required: false
        },
        customerMbwayPhoneNumber: {
            required: false
        },
        customerMbwayPhoneCountryCode: {
            required: false
        }
    },
    data() {
        return {
            expanded: false,
            validPromoCode: false,
            promocode: '',
            paymentFormError: {},
            promocodeError: {},
            payment_method: '2',
            phone: '',
            change_for: '',
            with_billing: 'yes',
            nif: this.customerNif,
            billing_name: this.customerName,
        }
    },
    created() {
       
    },
   
}

</script>

<style>

</style>
